import {initializeApp} from 'firebase/app';
import {initializeAppCheck, ReCaptchaV3Provider} from 'firebase/app-check';
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import {getStorage} from 'firebase/storage';
import {getFunctions} from 'firebase/functions';

// Web app "Owlly Web" registered in the owlly-37dbd Firebase project.
// This is public client config (same trust level as the mobile plist/json).
const firebaseConfig = {
  apiKey: 'AIzaSyCYQzMC15fIGy_pf1jXSBUzfyg0jhRedpQ',
  authDomain: 'owlly-37dbd.firebaseapp.com',
  projectId: 'owlly-37dbd',
  storageBucket: 'owlly-37dbd.firebasestorage.app',
  messagingSenderId: '894267219831',
  appId: '1:894267219831:web:55043f91ccf0b900238b72',
  measurementId: 'G-3JL7L8R5DV',
};

export const app = initializeApp(firebaseConfig);

// App Check attests that requests come from this site (reCAPTCHA v3). The
// site key is public config; it's created in the reCAPTCHA admin console and
// registered under Firebase → App Check → Owlly Web. Until the key is set
// requests simply carry no token, which the backend allows while
// enforcement is off — mirrors the mobile app's soft-fail in
// src/services/appCheckService.ts.
//
// Local dev: set VITE_APPCHECK_DEBUG_TOKEN to a debug token registered in
// the console; the SDK then skips reCAPTCHA (localhost isn't allowlisted).
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;
const appCheckDebugToken = import.meta.env.VITE_APPCHECK_DEBUG_TOKEN as string | undefined;
if (appCheckDebugToken) {
  (self as unknown as {FIREBASE_APPCHECK_DEBUG_TOKEN?: string}).FIREBASE_APPCHECK_DEBUG_TOKEN =
    appCheckDebugToken;
}
if (recaptchaSiteKey) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    console.warn('App Check init failed', e);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Cloud Functions are deployed to us-central1 (functions/src/config.ts).
export const functions = getFunctions(app, 'us-central1');
